var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRounded = function SvgArrowRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 24,
    fill: "none",
    viewBox: "0 0 11 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36.768A2.13 2.13 0 0 1 11 0v24a2.13 2.13 0 0 1-1.64-.768L1.6 13.92a3 3 0 0 1 0-3.842z"
  })));
};
export default SvgArrowRounded;